<script setup>
/* Knopf "Filter" neben der Suche (Kaderseite und Transfers-Seite). Die Zahl zeigt, wie viele Filter aktiv sind.
   Der Bereich, den er öffnet, steht in FilterBox.vue; den Zustand (offen/zu) hält die Seite. */
import { mdiFilterOutline } from '@mdi/js';

defineProps({
  count: { type: Number, default: 0 },
  panelId: { type: String, required: true },
});
const open = defineModel({ type: Boolean, default: false });
</script>

<template>
  <button
    type="button"
    class="btn ghost filter-toggle"
    :class="{ active: count > 0 }"
    :aria-expanded="open"
    :aria-controls="panelId"
    :aria-label="count ? $t('squad.filterToggleLabelActive', { count }) : $t('squad.filterToggleLabel')"
    data-testid="filter-toggle"
    @click="open = !open"
  >
    <v-icon :icon="mdiFilterOutline" size="18" />
    <span data-testid="filter-toggle-text">{{ count ? $t('squad.filterButtonActive', { count }) : $t('squad.filterButton') }}</span>
  </button>
</template>

<style scoped>
.filter-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: none;
  min-height: 46px;
  padding: 0 16px;
  white-space: nowrap;
}
</style>
